import React from 'react';
import { HippoComponentProps } from '../index';

import styles from './TextArea.module.scss';
import classNames from 'classnames';
import Icon from '../Icon/Icon';

export interface Props extends HippoComponentProps {
  error?: boolean;
  disabled?: boolean;
  assistiveText?: string;
  value?: string;
  placeholder?: string;
  label?: string;
  icon?: string;
  onChange?: (value: string) => void;
}

const TextArea: React.FC<Props> = ({
  dataQA,
  className,
  value,
  label,
  placeholder,
  assistiveText,
  disabled,
  error,
  icon,
  onChange,
}) => {
  return (
    <div
      data-qa={dataQA}
      className={classNames(styles.container, className, {
        [styles.disabled]: disabled,
        [styles.error]: error,
      })}
    >
      {label && <span className={styles.label}>{label}</span>}
      <div className={styles.inputContainer}>
        <div className={styles.content}>
          {icon && <Icon dataQA="icon" name={icon} size={24} />}
          <textarea
            className={styles.input}
            value={value}
            disabled={disabled}
            placeholder={placeholder}
            onChange={e => onChange && onChange(e.target.value)}
          />
        </div>
      </div>
      {assistiveText && (
        <span className={styles.assistiveText}>{assistiveText}</span>
      )}
    </div>
  );
};

export default TextArea;
